// Moss green from Figma for AI responses
const ASSISTANT_COLOR = "#638308";

interface StreamingMessageProps {
  content: string;
}

export function StreamingMessage({ content }: StreamingMessageProps) {
  if (!content) {
    return (
      <div style={{ color: ASSISTANT_COLOR }}>
        <div
          className="animate-spin rounded-full h-5 w-5 border-2 border-t-transparent"
          style={{ borderColor: ASSISTANT_COLOR, borderTopColor: "transparent" }}
        />
      </div>
    );
  }

  return (
    <div style={{ color: ASSISTANT_COLOR }}>
      <p className="whitespace-pre-wrap leading-relaxed text-base">
        {content}
        <span
          className="inline-block w-0.5 h-5 ml-0.5 animate-pulse align-text-bottom"
          style={{ backgroundColor: ASSISTANT_COLOR }}
        />
      </p>
    </div>
  );
}
